import React from "react";
import SupportLayout from "./supportLayout";
import Notice from "common/pages/common/-pages/support/Notice";
import Seo from "components/Seo";

const MorningNotice = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="공지사항" />
            <SupportLayout>
                <Notice type="morning" />
            </SupportLayout>
        </React.Fragment>
    );
};

export default MorningNotice;
